import type { RouteLocationNormalizedLoaded } from 'vue-router';

/** 默认走 keep-alive 的顶栏页签路由（由 Layout 按路由 name 判定，与组件 defineOptions name 无关） */
export const BASE_KEEP_ALIVE_ROUTE_NAMES = new Set([
  'ProjectDashboard',
  'ProjectCreate',
  'ProjectDocumentViewer',
  'ProjectWbsSnapshot',
  'KnowledgeSpace',
  'Dashboard',
  'AiSmartReview',
  'AiTools',
  'AiRequirementLedger',
  'AiRequirementDetail',
  'AiCalculator',
  'Ai3DViewer',
]);

export function collectKeepAliveRouteNames(openTabRouteNames: string[]): string[] {
  const names = new Set(BASE_KEEP_ALIVE_ROUTE_NAMES);
  for (const name of openTabRouteNames) {
    if (name) names.add(name);
  }
  return Array.from(names);
}

export function isRouteKeepAlive(
  targetRoute: Pick<RouteLocationNormalizedLoaded, 'name'>,
  includeNames: readonly string[],
): boolean {
  const name = String(targetRoute.name ?? '');
  return !!name && includeNames.includes(name);
}

/** 顶栏页签切换时用于 keep-alive 的实例 key（同项目/草稿复用缓存） */
export function routeKeepAliveCacheKey(
  targetRoute: Pick<RouteLocationNormalizedLoaded, 'name' | 'params' | 'query' | 'fullPath'>,
): string {
  const name = String(targetRoute.name ?? '');
  if (name === 'ProjectDashboard' || name === 'ProjectRequirements') {
    return `${name}:${String(targetRoute.params?.id ?? '')}`;
  }
  if (name === 'ProjectCreate') {
    return `ProjectCreate:${String(targetRoute.query?.draft ?? '')}`;
  }
  if (name === 'ProjectDocumentViewer') {
    return `ProjectDocumentViewer:${String(targetRoute.params?.id ?? '')}:${String(targetRoute.params?.objectKey ?? '')}`;
  }
  if (name === 'ProjectWbsSnapshot') {
    return `ProjectWbsSnapshot:${String(targetRoute.params?.id ?? '')}`;
  }
  if (name === 'AiSmartReview') {
    return 'AiSmartReview';
  }
  if (name === 'AiRequirementDetail') {
    return `AiRequirementDetail:${String(targetRoute.params?.id ?? '')}`;
  }
  return targetRoute.fullPath;
}
